/**
 * SEO Case Studies Slider JavaScript
 * Infinite continuous loop slider with dynamic gradient switching,
 * logo tab navigation, dot indicators, touch/drag support, auto-play,
 * and category tabs switching support.
 */
document.addEventListener('DOMContentLoaded', () => {
    function initSingleCaseStudiesSlider(csSection) {
        if (!csSection) return;

        const track = csSection.querySelector('.seo-cs-track');
        const sliderWindow = csSection.querySelector('.seo-cs-slider-window');
        const logoTabs = csSection.querySelectorAll('.logo-tab-btn');
        const dots = csSection.querySelectorAll('.dot-item');

        if (!track || !sliderWindow) return;

        const originalCards = Array.from(track.querySelectorAll('.seo-cs-main-card:not(.is-clone)'));
        const N = originalCards.length;
        if (N === 0) return;

        if (N === 1) {
            sliderWindow.classList.add('has-single-card');
            track.classList.add('has-single-card');
            if (csSection) csSection.classList.add('has-single-card');
            const singleCard = track.querySelector('.seo-cs-main-card');
            if (singleCard) {
                singleCard.classList.add('active');
            }
            const logoTabsWrap = csSection.querySelector('.seo-cs-logo-tabs');
            if (logoTabsWrap) {
                logoTabsWrap.classList.add('has-single-card');
            }
            track.style.transform = 'none';
            return;
        }

        // 1. Clone cards for seamless infinite continuous looping
        const existingClones = track.querySelectorAll('.is-clone');
        existingClones.forEach(c => c.remove());

        const freshCards = Array.from(track.querySelectorAll('.seo-cs-main-card'));
        
        // Head clones (append before original cards)
        const headClones = freshCards.map(card => {
            const clone = card.cloneNode(true);
            clone.classList.add('is-clone');
            return clone;
        });

        // Tail clones (append after original cards)
        const tailClones = freshCards.map(card => {
            const clone = card.cloneNode(true);
            clone.classList.add('is-clone');
            return clone;
        });

        headClones.reverse().forEach(clone => track.insertBefore(clone, track.firstChild));
        tailClones.forEach(clone => track.appendChild(clone));

        const allCards = Array.from(track.querySelectorAll('.seo-cs-main-card'));
        const totalCards = allCards.length; // 3 * N

        const initialRealIndex = 0;
        let trackIndex = N + initialRealIndex;
        let autoplayTimer = null;
        const intervalTime = 6000;

        function clampIndex(idx) {
            return Math.max(0, Math.min(idx, totalCards - 1));
        }

        function getTranslateXForIndex(idx) {
            const safeIdx = clampIndex(idx);
            const windowWidth = sliderWindow.offsetWidth || window.innerWidth;
            const cardWidth = allCards[safeIdx] ? allCards[safeIdx].offsetWidth : (allCards[0] ? allCards[0].offsetWidth : 0);
            const gap = window.innerWidth <= 767 ? 0 : 30;
            const centerOffset = (windowWidth - cardWidth) / 2;
            return centerOffset - (safeIdx * (cardWidth + gap));
        }

        function updateLogoTabsMode() {
            const logoTabsContainer = csSection.querySelector('.seo-cs-logo-tabs');
            if (!logoTabsContainer) return;

            const tabsArray = Array.from(logoTabs);
            if (tabsArray.length <= 1) {
                logoTabsContainer.classList.remove('is-slidable');
                return;
            }

            const isSmallScreen = window.innerWidth <= 767;
            const isMoreThanMobile = isSmallScreen && tabsArray.length > 3; // Slidable if > 3 tabs (since 3 fit perfectly)
            const isMoreThanDesktop = false;

            // Only make it slidable if more than 3 logos (mobile)
            if (isMoreThanMobile || isMoreThanDesktop) {
                logoTabsContainer.classList.add('is-slidable');
            } else {
                logoTabsContainer.classList.remove('is-slidable');
                logoTabsContainer.scrollTo({ left: 0, behavior: 'auto' });
            }
        }

        function updateActiveStates() {
            const currentRealIndex = ((trackIndex % N) + N) % N;
            
            allCards.forEach((card, i) => {
                const cardRealIndex = ((i % N) + N) % N;
                if (i === trackIndex || cardRealIndex === currentRealIndex) {
                    card.classList.add('active');
                } else {
                    card.classList.remove('active');
                }
            });

            updateLogoTabsMode();

            logoTabs.forEach((tab, i) => {
                if (i === currentRealIndex) {
                    tab.classList.add('active');

                    // If slidable, center active logo in container; otherwise don't slide
                    const logoTabsContainer = csSection.querySelector('.seo-cs-logo-tabs');
                    if (logoTabsContainer && logoTabsContainer.classList.contains('is-slidable')) {
                        const tabLeft = tab.offsetLeft;
                        const tabWidth = tab.offsetWidth;
                        const containerWidth = logoTabsContainer.clientWidth;
                        const targetScrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2);
                        logoTabsContainer.scrollTo({
                            left: Math.max(0, targetScrollLeft),
                            behavior: 'smooth'
                        });
                    }
                } else {
                    tab.classList.remove('active');
                }
            });

            dots.forEach((dot, i) => {
                if (i === currentRealIndex) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }

        function setTrackPosition(idx, animate = true) {
            const safeIdx = clampIndex(idx);
            if (animate) {
                track.style.transition = 'transform 0.6s cubic-bezier(0.25, 1, 0.5, 1)';
            } else {
                track.style.transition = 'none';
            }
            const tx = getTranslateXForIndex(safeIdx);
            track.style.transform = `translateX(${tx}px)`;
        }

        function normalizeTrackIndex() {
            if (trackIndex < N) {
                trackIndex += N;
                setTrackPosition(trackIndex, false);
                void track.offsetWidth;
            } else if (trackIndex >= 2 * N) {
                trackIndex -= N;
                setTrackPosition(trackIndex, false);
                void track.offsetWidth;
            }
        }

        function goToTrackIndex(targetIndex, animate = true) {
            const diff = targetIndex - trackIndex;
            normalizeTrackIndex();

            trackIndex = clampIndex(trackIndex + diff);
            updateActiveStates();
            setTrackPosition(trackIndex, animate);
        }

        function handleSeamlessWrap() {
            if (trackIndex < N) {
                trackIndex += N;
                setTrackPosition(trackIndex, false);
                updateActiveStates();
                void track.offsetWidth;
            } else if (trackIndex >= 2 * N) {
                trackIndex -= N;
                setTrackPosition(trackIndex, false);
                updateActiveStates();
                void track.offsetWidth;
            }
        }

        track.addEventListener('transitionend', (e) => {
            if (e.target === track) {
                handleSeamlessWrap();
            }
        });

        track.addEventListener('transitioncancel', (e) => {
            if (e.target === track) {
                handleSeamlessWrap();
            }
        });

        function nextSlide() {
            goToTrackIndex(trackIndex + 1, true);
        }

        function startAutoplay() {
            stopAutoplay();
            autoplayTimer = setInterval(nextSlide, intervalTime);
        }

        function stopAutoplay() {
            if (autoplayTimer) {
                clearInterval(autoplayTimer);
                autoplayTimer = null;
            }
        }

        // Pause autoplay on mouse hover and resume on leave
        csSection.addEventListener('mouseenter', () => {
            stopAutoplay();
        });

        csSection.addEventListener('mouseleave', () => {
            startAutoplay();
        });

        // Logo Tab Clicks
        logoTabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const targetReal = parseInt(tab.getAttribute('data-index'), 10);
                if (!isNaN(targetReal)) {
                    normalizeTrackIndex();
                    const currentReal = ((trackIndex % N) + N) % N;
                    let diff = targetReal - currentReal;
                    if (diff > N / 2) diff -= N;
                    if (diff < -N / 2) diff += N;

                    goToTrackIndex(trackIndex + diff, true);
                    startAutoplay();
                }
            });
        });

        // Dot Indicator Clicks
        dots.forEach(dot => {
            dot.addEventListener('click', () => {
                const targetReal = parseInt(dot.getAttribute('data-index'), 10);
                if (!isNaN(targetReal)) {
                    normalizeTrackIndex();
                    const currentReal = ((trackIndex % N) + N) % N;
                    let diff = targetReal - currentReal;
                    if (diff > N / 2) diff -= N;
                    if (diff < -N / 2) diff += N;

                    goToTrackIndex(trackIndex + diff, true);
                    startAutoplay();
                }
            });
        });

        // Card Clicks
        allCards.forEach((card, i) => {
            card.addEventListener('click', (e) => {
                if (card.classList.contains('active')) return;

                e.preventDefault();
                goToTrackIndex(i, true);
                startAutoplay();
            });
        });

        // Touch & Mouse Drag Support
        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTranslateX = 0;
        let hasDragged = false;

        function onDragStart(e) {
            isDragging = true;
            hasDragged = false;
            stopAutoplay();
            normalizeTrackIndex();
            startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
            startTranslateX = getTranslateXForIndex(trackIndex);
            track.style.transition = 'none';
        }

        function onDragMove(e) {
            if (!isDragging) return;
            currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
            const deltaX = currentX - startX;

            if (Math.abs(deltaX) > 5) {
                hasDragged = true;
            }

            track.style.transform = `translateX(${startTranslateX + deltaX}px)`;
        }

        function onDragEnd() {
            if (!isDragging) return;
            isDragging = false;

            const deltaX = currentX - startX;
            const threshold = 50;

            if (hasDragged && Math.abs(deltaX) > threshold) {
                if (deltaX < 0) {
                    goToTrackIndex(trackIndex + 1, true);
                } else {
                    goToTrackIndex(trackIndex - 1, true);
                }
            } else {
                goToTrackIndex(trackIndex, true);
            }
            startAutoplay();
        }

        sliderWindow.addEventListener('mousedown', onDragStart);
        window.addEventListener('mousemove', onDragMove);
        window.addEventListener('mouseup', onDragEnd);

        sliderWindow.addEventListener('touchstart', onDragStart, { passive: true });
        sliderWindow.addEventListener('touchmove', onDragMove, { passive: true });
        sliderWindow.addEventListener('touchend', onDragEnd);

        sliderWindow.addEventListener('click', (e) => {
            if (hasDragged) {
                e.preventDefault();
                e.stopPropagation();
                hasDragged = false;
            }
        }, true);

        csSection.addEventListener('mouseenter', stopAutoplay);
        csSection.addEventListener('mouseleave', startAutoplay);

        window.addEventListener('resize', () => {
            updateLogoTabsMode();
            setTrackPosition(trackIndex, false);
        });

        // Store recalculate method on DOM node
        csSection._recalcSlider = () => {
            updateLogoTabsMode();
            goToTrackIndex(trackIndex, false);
        };

        goToTrackIndex(trackIndex, false);
        startAutoplay();
    }

    // Initialize all case studies sliders / tab panes on page
    const allSliders = document.querySelectorAll('.seo-case-studies, .seo-apptunix-case-studies, .seo-cs-tab-pane');
    allSliders.forEach(slider => initSingleCaseStudiesSlider(slider));

    // Category Tabs Switching Handler
    const catTabButtons = document.querySelectorAll('.seo-cs-cat-tabs-wrap .cs-tab-btn');
    catTabButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const targetTab = btn.getAttribute('data-tab');
            if (!targetTab) return;

            const tabsWrapper = btn.closest('.seo-cs-tabs-wrapper') || document.querySelector('.seo-cs-tabs-wrapper');
            if (!tabsWrapper) return;

            // Update tab button states
            tabsWrapper.querySelectorAll('.cs-tab-btn').forEach(b => {
                if (b.getAttribute('data-tab') === targetTab) {
                    b.classList.add('active');
                } else {
                    b.classList.remove('active');
                }
            });

            // Smoothly center the clicked category tab button in the scrollable tabs bar
            const tabsContainer = btn.closest('.case-studies-tabs');
            if (tabsContainer) {
                const containerRect = tabsContainer.getBoundingClientRect();
                const btnRect = btn.getBoundingClientRect();
                const scrollOffset = (btnRect.left - containerRect.left) + tabsContainer.scrollLeft - (containerRect.width / 2) + (btnRect.width / 2);
                tabsContainer.scrollTo({
                    left: Math.max(0, scrollOffset),
                    behavior: 'smooth'
                });
            }

            // Update tab pane visibility
            tabsWrapper.querySelectorAll('.seo-cs-tab-pane').forEach(pane => {
                if (pane.getAttribute('data-tab-pane') === targetTab) {
                    pane.classList.add('active');
                    if (typeof pane._recalcSlider === 'function') {
                        setTimeout(() => pane._recalcSlider(), 50);
                    }
                } else {
                    pane.classList.remove('active');
                }
            });
        });
    });
});
